import { SubChartConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/plot-area/sub-chart/sub-chart-converter';
import { ChartShapeInfoConverter } from '../../common/chart-shape-info-converter';
import type { DeltaOf, IStockChartData } from '@tencent/slide-sdk-model';
import type { IStockChart } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';
import type { IChartBaseShapeProps } from '../../common/chart-shape-info-converter';
import { SubChartType } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sdk-model.interface';

export class StockChartConverter extends SubChartConverter {
    public static type = SubChartType.StockChart;
    public static convertSubChartDataSdkToUi(sdkData: IStockChartData, uiData: IStockChart) {
        super.convertSubChartDataSdkToUi(sdkData, uiData);
        if (sdkData.dropLines) {
            uiData.dropLines = {};
            ChartShapeInfoConverter.convertPartialDataFromSdkToUi(
                sdkData.dropLines as IChartBaseShapeProps,
                uiData.dropLines as IShapeModel,
            );
        }
        if (sdkData.hiLowLines) {
            uiData.highLowLines = {};
            ChartShapeInfoConverter.convertPartialDataFromSdkToUi(
                sdkData.hiLowLines as IChartBaseShapeProps,
                uiData.highLowLines as IShapeModel,
            );
        }
        if (sdkData.upDownBars) {
            const upDownBars: any = {};
            const { gapWidth, upBars, downBars } = sdkData.upDownBars;
            if (this.isInnerValNotNil(gapWidth)) {
                upDownBars.gapWidth = gapWidth.val;
            }
            if (upBars) {
                upDownBars.upBars = {};
                ChartShapeInfoConverter.convertPartialDataFromSdkToUi(
                    upBars as IChartBaseShapeProps,
                    upDownBars.upBars as IShapeModel,
                );
            }
            if (downBars) {
                upDownBars.downBars = {};
                ChartShapeInfoConverter.convertPartialDataFromSdkToUi(
                    downBars as IChartBaseShapeProps,
                    upDownBars.downBars as IShapeModel,
                );
            }
            uiData.upDownBars = upDownBars;
        }
    }

    // eslint-disable-next-line complexity
    public static convertSubChartDataUiToSdk(
        uiData: IStockChart,
        sdkData: DeltaOf<IStockChartData>,
    ) {
        super.convertSubChartDataUiToSdk(uiData, sdkData);

        if (uiData.dropLines !== undefined) {
            if (uiData.dropLines === null) {
                sdkData.dropLines = null;
            } else {
                sdkData.dropLines = sdkData.dropLines ?? {};
                ChartShapeInfoConverter.convertPartialDataFromUiToSdk(uiData.dropLines, sdkData.dropLines);
            }
        }
        if (uiData.highLowLines !== undefined) {
            if (uiData.highLowLines === null) {
                sdkData.hiLowLines = null;
            } else {
                sdkData.hiLowLines = sdkData.hiLowLines ?? {};
                ChartShapeInfoConverter.convertPartialDataFromUiToSdk(uiData.highLowLines, sdkData.hiLowLines);
            }
        }
        if (uiData.upDownBars !== undefined) {
            if (uiData.upDownBars === null) {
                sdkData.upDownBars = null;
            } else {
                sdkData.upDownBars = sdkData.upDownBars ?? {};
                const { upBars, downBars } = uiData.upDownBars;

                this.convertComplexValueUiToSdk(uiData.upDownBars, 'gapWidth', sdkData.upDownBars, 'gapWidth');

                if (upBars) {
                    sdkData.upDownBars.upBars = sdkData.upDownBars.upBars ?? {};
                    ChartShapeInfoConverter.convertPartialDataFromUiToSdk(upBars, sdkData.upDownBars.upBars);
                }
                if (downBars) {
                    sdkData.upDownBars.downBars = sdkData.upDownBars.downBars ?? {};
                    ChartShapeInfoConverter.convertPartialDataFromUiToSdk(downBars, sdkData.upDownBars.downBars);
                }
            }
        }
    }
}
